module.exports = __webpack_public_path__ + "media/dashboard/assets/images/bank/bsi-logo-fd900b3c8f41199fbb962a7692b47d60.png";